import React, { useEffect, useState } from "react";
import styles from "./EmailVerification.module.css";
import emailIcon from "../../assests/emailIcon.svg";
import { useUserAuth } from "../../context/UserAuthContext";
import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";
import singinCloseButton from "../../assests/singinCloseButton.svg";
import success from "../../assests/share/copySuccessRound.svg";

const EmailVerification = ({ setPopup, closedCampaign }) => {
  console.log("closedCampaign", closedCampaign);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const [sented, setSented] = useState(false);
  const [otp, setOtp] = useState();

  const {
    emailVerification,
    emailVerificationGoviral,
    currentUser,
    pageLoading,
    setPageLoading,
    emailError,
    setEmailError,
    emailVerified,
    fetchUserData,
    verifyEmailOtp,
  } = useUserAuth();

  const handleEmailVerification = async () => {
    setSented(false);
    setEmailError("");
    setOtp();
    await emailVerificationGoviral(
      currentUser?.email,
      currentUser?.accessToken
    );
    setSented(true);
  };

  return (
    <div className={styles.mainDiv}>
      <div className={styles.container}>
        <div className="w-[100%] flex justify-end p-[10px] cursor-pointer">
          {(!closedCampaign || emailVerified) && (
            <img
              src={singinCloseButton}
              onClick={() => {
                setEmailError(false);
                setPageLoading(false);
                setPopup(false);
              }}
            />
          )}
        </div>
        {/* <img
          src={LikedAlready}
          alt=""
          className="w-[56px] h-[56px] mb-[24px]  "
        /> */}
        {/* <p className="text-regular-medium px-[20px] mb-[16px]">
          Option to dislike is disabled
        </p> */}

        <h3 className="text-regular-medium mb-[14px]">
          Please verify your email
        </h3>
        <pre className="text-small text-opacity-80 mb-[25px] md-w-[90%]">
          {sented
            ? "Enter the OTP to verify your account."
            : `We will send a one-time password (OTP) to ${currentUser?.email} from goviralit@gmail.com.
Enter the OTP to verify your account.`}
        </pre>

        {emailVerified ? (
          <div className="text-regular-medium flex items-center w-full justify-center gap-[5px]">
            Verified <img src={success} alt="" className="w-[36px] h-[36px]" />
          </div>
        ) : (
          <>
            {sented ? (
              <>
                <p
                  className="text-small cursor-pointer"
                  onClick={handleEmailVerification}
                  disabled={pageLoading}
                >
                  Didn't receive the email?{" "}
                  <span className="text-[#3075FC]">Resend email</span>
                </p>

                <div className="w-[80%]">
                  <input
                    type="number"
                    id="otp"
                    name="otp"
                    placeholder="Enter OTP"
                    className="text-regular-callout my-[16px] w-full"
                    onChange={(e) => setOtp(e.target.value)}
                    value={otp}
                  />
                  <button
                    className={`${styles.button} text-regular-medium bg-[#7AC280] flex items-center justify-center gap-[14px] w-full`}
                    onClick={() => verifyEmailOtp(otp)}
                    disabled={pageLoading}
                  >
                    Submit OTP
                  </button>
                </div>
              </>
            ) : (
              <button
                className={`${styles.button} text-regular-medium bg-[#7AC280]   flex items-center justify-center gap-[14px] drop-shadow-lg`}
                onClick={handleEmailVerification}
                disabled={pageLoading}
              >
                <img src={emailIcon} alt="" className="h-[24px] w-[24px]" />
                Send Email
              </button>
            )}
          </>
        )}

        <div className="w-full p-[10px] flex flex-col items-center">
          {emailError && (
            <div className="text-small text-center w-[100%] mb-[12px]">
              <span className="text-red-600">*</span>
              {emailError}
            </div>
          )}
          {pageLoading && !emailVerified && <LoadingFromCenter />}
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;
